import {ApplicationRef, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {CommunicationService} from '../../../service/communication.service';
import {DialogViewModelCreatorService} from '../../../service/dialog-view-model-creator.service';
import {BotatoChatManagerService} from '../../../service/botato-chat-manager.service';
import {InputComponent} from '../input.component';
import {InputDataService} from '../../input-data.service';
import {Subscription} from 'rxjs';
import {
    DialogConfigInputOptionsListInput, DialogConfigInputType
} from 'botato-botengine-browser/botato/botato-botengine/source/Core/DialogConfig/DialogConfig.js';

@Component({
    templateUrl: './list-input.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ListInputComponent extends InputComponent<DialogConfigInputOptionsListInput> implements OnInit, OnDestroy {

    public static TYPE: DialogConfigInputType = 'list';
    public isConnected: boolean | undefined;
    public selectValues: string[] | undefined;
    @ViewChild('selectInput', {static: true})
    private messageInput!: ElementRef;

    private subscription = new Subscription();
    private selectedValue: string | undefined;

    constructor(private communicationService: CommunicationService,
                public dialogViewModelCreator: DialogViewModelCreatorService,
                private chatManagerService: BotatoChatManagerService,
                private applicationRef: ApplicationRef,
                private inputDataService: InputDataService,
                private changeDetectorRef: ChangeDetectorRef) {
        super();
    }

    public ngOnInit(): void {
        this.inputDataService.getDataList(this.requireInputOptions().dataKey).subscribe((values) => {
            this.selectValues = values;
            // markForCheck is safe both inside and outside a running tick, unlike the tick() it replaces
            this.changeDetectorRef.markForCheck();
        });


        this.subscription.add(this.chatManagerService.focusInput$.subscribe(() => this.messageInput.nativeElement.focus()));
        this.subscription.add(this.communicationService.connectionStateChanged.subscribe((state: boolean) => {
            this.isConnected = state;
            this.changeDetectorRef.markForCheck();
        }));
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    public async sendUserText(): Promise<void> {
        if (this.selectedValue === undefined) {
            return;
        }
        await this.sendMessage(this.selectedValue);
        this.applicationRef.tick();
    }

    public canSendMessage(): boolean {
        return this.selectedValue !== undefined && this.selectValues !== undefined && this.isConnected === true;
    }

    public setValue(value: string): void {
        this.selectedValue = value === '' ? undefined : value;
        this.applicationRef.tick();
    }

    private async sendMessage(text: string): Promise<void> {
        this.dialogViewModelCreator.addUserTextMessage(text);
        await this.communicationService.sendMessage(text, 'list');
    }
}
